import { gql } from "@apollo/client";

export const ReadInterventionNotification = gql`
  mutation ReadInterventionNotification($id: String!) {
    readInterventionNotification(id: $id) {
      _id
    }
  }
`;
